export default __webpack_public_path__ + "static/media/card.7805e2dc.png";